<script setup lang="ts">
import BaseIcon from "../../icons/BaseIcon.vue";
</script>

<template>
  <div class="command-palette-info">
    <div class="flex items-center gap-2 justify-center">
      <BaseIcon
        name="heroicons:globe-europe-africa"
        class="command-palette-info__icon"
        aria-hidden="true"
      />

      <div class="h-4 w-px bg-gray-200" />

      <BaseIcon
        name="heroicons:wifi"
        class="command-palette-info__icon"
        aria-hidden="true"
      />
    </div>
    <p class="command-palette-info__text">Find an event, product or customer</p>
    <p class="command-palette-info__extra-info-text">
      Quickly access events, product listings, or customers by running a global
      search or scanning the Fabricks chip on a product.
    </p>
  </div>
</template>

<style scoped lang="postcss">
.command-palette-info {
  @apply border-t border-gray-600 py-14 px-6 text-center text-sm sm:px-14;

  &__icon {
    @apply h-6 w-6 text-gray-400;
  }

  &__text {
    @apply mt-4 font-semibold text-gray-900;
  }

  &__extra-info-text {
    @apply mt-2 text-gray-500;
  }
}
</style>
